import React from "react";
import { withStyles } from "@material-ui/core/styles";
import PopupModal from "../PopupModal";
import Typography from "../Typography";
import ImageDialog from "./dialog.js";
import "./index.css";
import uploadAsset from "./uploadAsset";
import PropTypes from "prop-types";
import { createProportionalDimensions } from "./common";

const styles = (theme) => ({
  root: {
    // padding: "16px",
    // [theme.breakpoints.up("md")]: {
    //   padding: "24px"
    // }
  },
  label: {
    border: "1px solid #DDD",
    padding: "10px",
    textAlign: "center",
    borderStyle: "dashed",
    cursor: "pointer",
  },
  dimensions: {
    textAlign: "center",
  },
  thumbnail: {
    width: "200px",
    margin: "auto",
  },
  overlay: {
    width: "200px",
    position: "absolute",
    margin: "auto",
    left: 0,
    top: 0,
    bottom: 0,
    right: 0,
    opacity: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "&:hover": {
      background: "black",
      opacity: 0.8,
    },
  },
  optionsContainer: {
    width: "150px",
  },
  option: {
    border: "1px solid white",
    borderRadius: 5,
    color: "white",
    width: "150px",
    background: "transparent",
    margin: "4px",
  },

  uploadImage: {
    width: "125px",
    height: "75px",
  },
  imageUploadMain: {
    marginTop: "32px",
  },
  replaceBtn: {
    cursor: "pointer",
  },
  fieldLabel: {
    marginBottom: "5px",
  },
  backgroundColor: {
    // background: "#7ADDFF"
  },
  imageThumb: {
    backgroundRepeat: "no-repeat !important",
    backgroundPosition: "center !important",
    backgroundSize: "contain !important",
    width: "125px",
    height: "75px",
    position: "relative",
  },
});

class ImageUploader extends React.PureComponent {
  canvas = {};
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      file: "",
      crop: false,
      filename: "",
      fileFrom: "others",
      categoryId: props.categoryId,
      hideFromList: false,
      dimension_width: props.dimension_width,
      dimension_height: props.dimension_height,
      uploaded: props.fieldImage || "",
      croppedImage: "",
      notification: false,
      notificationId: 0,
      notificationType: "",
      notificationBody: "",
      notificationPermanent: false,
      thumbnail: props.fieldImage || "",
      uploading: false,
      selectedTab: 0,
      loading: false,
      blackOverlay: false,
      deleteModal: false,
    };
    this.child = React.createRef();
  }

  handleOpen = () => {
    if (this.props.mobileView <= 600) {
      this.props.handleNotification(
        "Image uploads are not supported from a mobile device.",
        "warning"
      );
    } else {
      this.setState({
        open: true,
        crop: false,
        uploaded: false,
        croppedImage: "",
        file: "",
        filename: "",
      });
    }
  };

  handleReplace = () => {
    if (this.props.mobileView <= 600) {
      this.props.handleNotification(
        "Image uploads are not supported from a mobile device.",
        "warning"
      );
    } else {
      this.setState({
        open: true,
        crop: false,
        file: "",
        filename: "",
        croppedImage: "",
      });
    }
  };

  handleDelete = () => {
    if (this.props.mobileView <= 600) {
      this.props.handleNotification(
        "Image uploads are not supported from a mobile device.",
        "warning"
      );
    } else {
      this.setState({
        deleteModal: false,
      });
      this.props.handleDeleteImage(this.props.fieldField);
    }
  };

  handleDeleteModal = () => {
    this.setState({
      deleteModal: true,
    });
  };

  cancelDeleteModal = () => {
    this.setState({
      deleteModal: false,
    });
  };

  handleUpload = image => {
    var self = this;
    if (image) {
      let { propertyId, environment, onUploadFinish, categoryId, base64 } = self.props;
      if (base64) {
        self.setState({
          uploaded: true,
          cropper: false,
          open: false,
          uploading: false
        });
        return onUploadFinish(image)
      }
      self.setState(prevState => ({
        croppedImage: image,
        thumbnail: prevState.file,
        uploading: true
      }));
      let input = {
        name: self.state.filename,
        imageData: image,
        propertyId: propertyId || "fake_id",
        categoryId: self.state.categoryId || categoryId,
        hideFromList: self.state.hideFromList
      };
      uploadAsset(input, environment, res => {
        self.setState({
          uploaded: true,
          cropper: false,
          open: false,
          uploading: false
        });
        if (res.uploadAsset !== null) {
          if (res && !res.errors) {
            if (typeof onUploadFinish === "function") {
              onUploadFinish(res.uploadAsset.asset.fileUrl, this.props.fieldField);
            }
          } else {
            self.props.handleNotification(
              "fail",
              `Something went wrong, please try after sometime.`,
              false
            );
          }
        } else {
          self.props.handleNotification(
            "fail",
            `Something went wrong, please try after sometime.`,
            false
          );
        }
      });
    } else {
      self.props.handleNotification("fail", `Please try again!`, false);
    }
  };

  makeWhiteSpace = (file, fileFrom, categoryId) => {
    if (file) {
      var self = this;
      let width = Number(file.imageDimension.split("x")[0]);
      let height = Number(file.imageDimension.split("x")[1]);
      let required_dimensions = createProportionalDimensions(width, height);
      let required_width = Number(required_dimensions.split("x")[0]);
      let required_height = Number(required_dimensions.split("x")[1]);
      let white_space =
        width < 600 ? Math.round((required_width - width) / 2) : 0;
      let srcImage = file.imageUrl;

      let img = new Image();
      img.crossOrigin = "anonymous";
      img.src = srcImage;
      let canvas = document.createElement("canvas");
      canvas.width = required_width;
      canvas.height = required_height;
      let ctx = canvas.getContext("2d");
      img.onload = function () {
        ctx.drawImage(
          img,
          white_space,
          0,
          white_space === 0 ? required_width : width,
          required_height
        );
        let proportionalImage = canvas.toDataURL("image/png");

        self.setState({
          file: proportionalImage,
          filename: new Date().getTime() + ".jpg",
          crop: true,
          uploaded: false,
          selectedTab: 0,
          loading: false,
          fileFrom: fileFrom,
          hideFromList: true,
          dimension_width: required_width,
          dimension_height: required_height,
        });
      };
    }
  };

  handleGalleryImage = (fileFrom, categoryId, file) => {
    var self = this;
    if (self.state.crop) self.child.current.handleReferenceMethod();
    let { dimension_width, dimension_height } = self.props;
    self.setState({ loading: true });
    if (fileFrom === "floorPlan") {
      self.makeWhiteSpace(file, fileFrom, categoryId);
    } else {
      var image = file.imageUrl ? file.imageUrl : file.fileUrl;
      var xhr = new XMLHttpRequest();
      xhr.open("GET", image, true);
      xhr.responseType = "blob";
      xhr.onload = function (e) {
        var reader = new FileReader();
        reader.onload = function (event) {
          var res = event.target.result;
          var img = new Image();
          img.src = res;
          img.onload = () => {
            if (img.width < dimension_width && img.height < dimension_height) {
              self.props.handleNotification(
                `Image size cannot be smaller than ${dimension_width} x ${dimension_height}px. Please upload recommended size image.`,
                "warning"
              );
              self.setState({ loading: false });
            } else {
              self.setState({
                file: res,
                filename: new Date().getTime() + ".jpg",
                crop: true,
                uploaded: false,
                selectedTab: 0,
                loading: false,
                fileFrom: fileFrom,
                hideFromList: true,
                dimension_width: dimension_width,
                dimension_height: dimension_height,
              });
            }
          };
        };
        var file = this.response;
        reader.readAsDataURL(file);
      };
      xhr.onerror = function (e) {
        self.props.handleNotification(
          `Something went wrong! Please try after sometime`,
          "warning"
        );
        self.setState({ loading: false });
      };
      xhr.send();
    }
  };

  handleClose = () => {
    this.handleCancel();
    this.setState((prevState) => ({
      open: false,
    }));
  };

  handleClick = () => {
    this.setState({
      file: "",
    });
  };

  // handleNotification = (type, body, permanent) => {
  //   this.setState({
  //     notification: true,
  //     notificationId: this.state.notificationId + 1,
  //     notificationType: type,
  //     notificationBody: body,
  //     notificationPermanent: permanent,
  //   });
  // };

  handleValidation = (file) => {
    var self = this;
    if (
      file.type === "image/jpeg" ||
      file.type === "image/jpg" ||
      file.type === "image/png" ||
      file.type === "image/gif" ||
      file.type === "image/ico"
    ) {
      self.setState({ loading: true });
      let floorPlan;
      // let floorPlan = this.props.fieldField
      //   .replace(/_/g, "")
      //   .replace(/ /g, "")
      //   .toUpperCase()
      //   .includes("FLOORPLAN");
      var img = new Image();
      if (floorPlan) {
        img.src = window.URL.createObjectURL(file);
        img.onload = function () {
          var file = {};
          file.imageDimension = this.width + "x" + this.height;
          file.imageUrl = img.src;
          self.makeWhiteSpace(file, "floorPlan", "");
        };
      } else {
        let { dimension_width, dimension_height } = this.props;
        if (file.size < 10000000) {
          img.src = window.URL.createObjectURL(file);
          img.onload = function () {
            if (
              img.naturalWidth < dimension_width &&
              img.naturalHeight < dimension_height
            ) {
              self.props.handleNotification(`Image size cannot be smaller than ${dimension_width} x ${dimension_height}px. Please upload recommended size image.`, "warning"
              );
            } else {
              self.setState({
                file: img.src,
                filename: file.name,
                crop: true,
                uploaded: false,
                loading: false,
                fileFrom: "others",
                hideFromList: false,
              });
            }
          };
        } else {
          self.props.handleNotification(
            "Image should be less than 10 MB",
            "warning"
          );
          self.setState({ loading: false });
        }
      }
    } else {
      self.props.handleNotification(
        "File extension must be jpg, jpeg, png, gif, ico",
        "warning"
      );
      self.setState({ loading: false });
    }
  };

  handleChange = (files) => {
    this.handleValidation(files[0]);
  };

  handleDrop = (file) => {
    this.handleValidation(file[0]);
  };

  handleCancel = () => {
    let { thumbnail } = this.state;
    this.setState({
      crop: false,
      file: "",
      croppedImage: "",
      filename: "",
      uploaded: thumbnail ? true : false,
    });
  };

  handleRemove = () => {
    this.setState({
      crop: false,
      file: "",
      croppedImage: "",
      thumbnail: "",
      filename: "",
      uploaded: false,
    });
  };

  handleTab = (e, i) => {
    this.setState({
      selectedTab: i,
    });
  };

  handleMouseEnter = () => {
    this.setState({
      blackOverlay: true,
    });
  };

  handleMouseLeave = () => {
    this.setState({
      blackOverlay: false,
    });
  };

  render() {
    const {
      classes,
      label,
      description,
      tabs,
      uploadIcon,
      fileTypeMsg,
      fieldLabel,
      fieldImage,
      fieldDisplay,
      propertyId,
      environment,
    } = this.props;
    const {
      open,
      crop,
      file,
      dimension_width,
      dimension_height,
      notification,
      notificationId,
      notificationType,
      notificationBody,
      notificationPermanent,
      uploaded,
      uploading,
      selectedTab,
      loading,
      blackOverlay,
      deleteModal,
    } = this.state;
    return (
      <div className={classes.root}>
        {uploaded && fieldDisplay === "block" ? (
          <>
            <div className={classes.imageUploadMain}>
              <Typography
                type="subtitle"
                color="deepGrey"
                className={classes.fieldLabel}
              >
                {dimension_width && dimension_height
                  ? fieldLabel +
                  " (" +
                  dimension_width +
                  "x" +
                  dimension_height +
                  "px)"
                  : "Loading..."}
              </Typography>

              <div
                style={{
                  backgroundImage: `url(${fieldImage})`,
                  backgroundColor: fieldImage.includes("png") ? "#26bbed" : "",
                }}
                className={classes.imageThumb}
                onMouseEnter={this.handleMouseEnter}
                onMouseLeave={this.handleMouseLeave}
              >
                {blackOverlay && (
                  <div className="overlayMain">
                    <div className="imageActions">
                      <div className="action-main">
                        <div
                          className="imageButton"
                          onClick={this.handleReplace}
                        >
                          Replace
                        </div>
                      </div>
                      <div className="action-main">
                        <div
                          className="imageButton"
                          onClick={this.handleDeleteModal}
                        >
                          Delete
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </>
        ) : (
            <div onClick={this.handleOpen}>
              {
                this.props.customButton ?
                  <div>{this.props.customButton}</div> :
                  <div className={classes.label} >
                    <Typography type="body1" color="deepGrey">
                      + {label}
                    </Typography>
                    <div className={classes.dimensions}>
                      <Typography type="subtitle" color="deepGrey">
                        {dimension_width && dimension_height
                          ? description +
                          " " +
                          dimension_width +
                          "x" +
                          dimension_height +
                          "px"
                          : "Loading..."}
                      </Typography>
                    </div>
                  </div>
              }
            </div>
          )}

        <ImageDialog
          ref={this.child}
          tabs={tabs}
          uploadIcon={uploadIcon}
          fileTypeMsg={fileTypeMsg}
          open={open}
          handleClose={this.handleClose}
          handleChange={this.handleChange}
          handleCancel={this.handleCancel}
          crop={crop}
          file={file}
          handleClick={this.handleClick}
          handleDrop={this.handleDrop}
          handleUpload={this.handleUpload}
          uploaded={uploaded}
          dimension_width={dimension_width}
          dimension_height={dimension_height}
          notification={notification}
          notificationId={notificationId}
          notificationType={notificationType}
          notificationBody={notificationBody}
          notificationPermanent={notificationPermanent}
          environment={environment}
          propertyId={propertyId}
          uploading={uploading}
          handleGalleryImage={this.handleGalleryImage}
          selectedTab={selectedTab}
          handleTab={this.handleTab}
          loading={loading}
        />

        <PopupModal
          loading={false}
          open={deleteModal}
          header="Confirm Deletion"
          title="Are you sure you want to delete this image?"
          actionButton="Delete"
          handleAction={this.handleDelete}
          handleCancel={this.cancelDeleteModal}
          actions={true}
        />
      </div>
    );
  }
}

ImageUploader.propTypes = {
  dimension_width: PropTypes.number,
  dimension_height: PropTypes.number,
  description: PropTypes.string,
};

ImageUploader.defaultProps = {
  dimension_width: 600,
  dimension_height: 340,
  description: "The image should be",
};

export default withStyles(styles)(ImageUploader);
